<contest-select *ngIf="competitionId"
                class="full-width"
                [competitionId]="competitionId"
                (selected)="contestSelected($event)"></contest-select>

<mat-spinner *ngIf="contestLoading" color="primary" diameter="20" class="center"></mat-spinner>

<div *ngIf="contest && !contestLoading && showDetails" fxLayout="row" fxLayout.lt-sm="column" class="contest-details">
  <div fxFlex="80%">
    <div class="additional-info">
      <span class="text-disabled-color"
            i18n="Contest Enrol Modal|Contest Enrol period section title@@contest-enrol-modal-period-section-title">
        Period:
      </span>
      {{contest.startsAt | date: mobileView ? 'short' : 'medium'}}
      - {{contest.endsAt | date: mobileView ? 'short' : 'medium'}}

      <span *ngIf="contest.endsAt && contest.endsAt <= today" class="color-warn">
        (
        <ng-container
          i18n="Contest Enrol Modal|Contest ended info message@@contest-enrol-contest-ended-info-message">contest ended</ng-container>
        )
      </span>
      <span *ngIf="contest.startsAt && contest.endsAt && contest.startsAt <= today && contest.endsAt > today"
            class="color-green">
        (
        <ng-container
          i18n="Contest Enrol Modal|Contest in progress info message@@contest-enrol-contest-in-progress-info-message">contest in progress</ng-container>
        )
      </span>
    </div>

    <div class="additional-info">
      <span class="text-disabled-color subsection-header"
            i18n="Contest Enrol Modal|Contest Enrol price section title@@contest-enrol-modal-price-section-title">
        Price:
      </span>
      <span *ngIf="contest.price && contest.price > 0">
        {{contest.price / 100}}
        <ng-container i18n="General|Currency UAH title@@general-currency-uah-title">UAH</ng-container>
      </span>
      <span *ngIf="!contest.price || contest.price <= 0" class="color-green free-price"
            i18n="Contest Enrol Modal|Contest Enrol free price title@@contest-enrol-modal-free-price-title">Free</span>
    </div>
  </div>

  <div class="fill-space"></div>

  <div *ngIf="additionalCtaShow" class="additional-cta-block">
    <app-button [label]="additionalCta"
                color="primary"
                [width]="additionalCtaWidth"
                [disabled]="additionalCtaDisabled"
                (clicked)="additionalCtaClicked.emit(contest)"></app-button>
  </div>
</div>
